<template>
  <div class="field" :class="{ 'is-fullwidth': isFullWidth }">
    <label class="label" v-if="label">{{ label }}</label>
    <div class="control" :class="{ 'has-icons-right': isSearch && isNonEmpty }">
      <input
        class="input"
        :class="{ 'is-danger': errors && errors.length > 0 }"
        :type="inputType"
        :placeholder="placeholder"
        :value="value"
        :step="step"
        :min="min"
        :disabled="disabled"
        :maxlength="maxlength"
        @input="onInput"
        @focus="onFocus"
        @change="onChange"
        @blur="onBlur"
        ref="input"
      />
      <span
        v-if="isSearch && isNonEmpty"
        @click="onResetInput"
        class="reset-button icon is-small is-right"
      >
        <i class="fa fa-times" />
      </span>
      <p class="help is-danger" v-if="errors && errors[0]">
        {{ $t(errors && errors[0]) }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "input-field",
  props: [
    "value",
    "label",
    "type",
    "placeholder",
    "errors",
    "step",
    "min",
    "disabled",
    "maxlength",
    "isFullWidth"
  ],
  computed: {
    isSearch() {
      return this.type === "search"
    },
    isNonEmpty() {
      return this.value && this.value.length > 0
    },
    inputType() {
      return this.isSearch ? "text" : this.type
    }
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value)
    },
    onChange(e) {
      this.$emit("change", e.target.value)
    },
    onFocus(e) {
      this.$emit("focus", e.target.value)
    },
    onBlur(e) {
      this.$emit("blur", e.target.value)
    },
    onResetInput() {
      this.$emit("input", "")
      this.$emit("change", "")
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.control.has-icons-right .reset-button {
  cursor: pointer;
  pointer-events: initial;
}
.is-fullwidth {
  width: 100%;
}
</style>
